
<row :class="verticalAlignmentClass" :type="rowType">
  <template v-for="(element, index) in elements">
    <slot
      name="element"
      v-if="element"
      :element="element"
      :gridIndex="index"
      :classes="classes(index)"
    ></slot>
    <slot
      name="empty"
      v-else
      :gridIndex="index"
      :classes="classes(index)"
    ></slot>
    <div v-if="isRowEnd(index)" class="clearfix"></div>
  </template>
</row>
